<template lang="pug">
.reset-password
  .reset-password__inner
    p.reset-password__heading(v-if="!resetPasswordContent") {{bodyCopy.heading}}
    p.reset-password__subheading(v-if="!resetPasswordContent") {{bodyCopy.subheading}}
    form.reset-password__form(v-on:submit.prevent="processReset" v-if="!resetPasswordContent")
      input.reset-password__input.reset-password__input--email(type='email', :placeholder="bodyCopy.inputFieldWatermarkText", id="reset-email", name="reset-email", :disabled="isDisabled" required v-model="resetPassword")
      .registration-flyout__error-wrapper(v-if="isError")
        AlertError(:error="{description: isError, id:'reset'}")
      button.reset-password__input.reset-password__input--reset(type="button" :disabled="isDisabled" @click="toggleLogin()") {{bodyCopy.cancelButtonText}}
      input.reset-password__input.reset-password__input--submit(type='submit' :value="bodyCopy.submitButtonText" :disabled="isDisabled")
    div.reset-password__success(v-if="resetPasswordContent" v-html="resetPasswordContent") 
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import AlertError from "../components/AlertError.vue"
export default {
  name: "PageResetPassword",
  components: {
    AlertError,
  },
  data() {
    return{
      // copy: loginCopy.loginPage.default,
      copyEndpoint: '/api/userdashboard/getcontent/passwordreset',
      endpoint: '/api/account/sendpasswordresetrequest',
      bodyCopy: {
        heading: 'Password Reset',
        subheading: 'Please verify and re-enter your email',
        inputFieldWatermarkText: 'Email Address',
        submitButtonText: 'Continue',
        cancelButtonText: 'Go Back'
      },
      // formData: {
      //   resetEmail: loginEmail
      // }
      resetPassword: '',
    }
  },
  computed: {
		...mapGetters(["isError", "isDisabled", "resetEmail", "resetPasswordContent", "isLoading"]),
    // resetPassword: {
    //   get() {
    //     return this.resetEmail
    //   },
    //   set(val) {
    //     return this.setResetEmail(val)
    //   }
    // }
  },
	methods: {
		...mapMutations(["setDisabled", "setError", "setResetEmail", "setResetPassword", "setAccountExist", "setLoading"]),
		...mapActions(["submitResetPassword"]),
    processReset(data) {
      data.preventDefault()
      const endpoint = this.endpoint
      // const email = this.resetEmail
      const email = {"email":this.resetPassword}
      // console.log(email)
      // clarify with alan re: responses
      this.setDisabled(true)
      this.setLoading(true)
      this.submitResetPassword({email, endpoint})
    },
    toggleLogin() {
      // e.preventDefault()
      this.setAccountExist(true)
      this.setResetPassword(false)
      this.setDisabled(false)
    },   
  },
  mounted() {
    this.setLoading(true)
    this.setError(false)
    fetch(this.copyEndpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }).then((response) => response.json())
      .then((data) => {
        this.bodyCopy = Object.assign(data)
        setTimeout(() => {
          this.setLoading(false)
        }, 1000);
      });
  },
};
</script>

<style lang="scss">
.reset-password {
  background: var(--registration-blue);
  color: $white;
  font-family: var(--registration-font-family);
  padding: 2.0625rem 3.3125rem 0 1.1875rem;
  .pageHeading {
    color: #fff;
    font-size: 2em;
    font-weight: 600;
    margin-bottom: var(--registration-gap-base);
    font-family: var(--registration-font-family-bold);
  }
  a {
    color: var(--registration-button-teal);
    &:hover {
      color: var(--registration-button-teal-hover);
    }
  }
  &__inner {

  }
  &__heading {
      font-size: 2em;
      font-weight: 600;
      margin-bottom: var(--registration-gap-base);
      font-family: var(--registration-font-family-bold);
  }
  &__subheading {
      font-weight: 600;
      font-family: var(--registration-font-family-bold);
      font-size: 1.15em;
      margin-bottom: calc(var(--registration-gap-base)*.5);
      @media screen and (min-width: 768px) {
          margin-bottom: calc(var(--registration-gap-base)*2);
      }        
  }
  &__content {
      color: var(--registration-light-gray);
      font-family: var(--registration-font-family-serif);
      margin-bottom: var(--registration-gap-base);
      a {
          color: $white;
          font-weight: 600;
          &:hover {
              text-decoration: underline;
          }
      }
  }
  &__form {
      display: flex;
      flex: 1 1 auto;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
  }
  &__input {
      background: none;
      flex: 0 0 100%;
      border-top: none;
      border-left: none;
      border-right: none;
      border-bottom: 4px solid var(--registration-light-gray);
      color: var(--registration-light-gray);
      margin-bottom: 12px;
      padding: calc(var(--registration-gap-base)*.5) 0;
      border-radius: 0;
      
      &::placeholder {
          color: var(--registration-light-gray);
      }
      &--email {
      }
      &--password {
          
      }
      &--submit,
      &[type='submit'],
      &--reset {
          background-color: var(--registration-button-blue);
          border-bottom: none;
          color: $white;
          @media screen and (min-width: 768px) {
              flex: 0 1 49%;
          }
          &:hover{
              background-color: var(--registration-button-blue-hover)
          }
      }
      &--reset {
        background-color: var(--registration-button-teal);
        &:hover {
          background-color: var(--registration-button-teal-hover);
        }
        text-align: center;
      }
      // &--register {
      //     background-color: var(--registration-button-teal);
      //     &:hover {
      //         background-color: var(--registration-button-teal-hover)
      //     }
      // }
  }
  &__reset {
      color: var(--registration-button-teal);
      display: block;
      font-weight: 400;
      margin-top: var(--registration-gap-base);
      margin-bottom: calc(var(--registration-gap-base));
      @media screen and (min-width: 768px) {
          margin-bottom: calc(var(--registration-gap-base) * 1.5);
      }        
      &:hover {
          color: var(--registration-button-teal-hover);
      }
  }
  &__register {
    color: #fff;
    @media screen and (min-width: 768px) {
      margin-bottom: calc(var(--registration-gap-base) * 3);
    } 
    span {
      color: var(--registration-button-teal);
      cursor: pointer;
      &:hover {
          color: var(--registration-button-teal-hover);
          text-decoration: underline;
      }
    }
  }
  &__content {
    strong {
      color: #fff;
    }
    a {
      color: var(--registration-button-teal);
      &:hover {
          color: var(--registration-button-teal-hover);
      }
    }
  }
}

</style>
